export default __webpack_public_path__ + "static/favicon-6d68c4a58f27d19dc2fd6816587ba151.ico";